import React, { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const GetInTouch = () => {
    const revealRefs = useRef([]);

    const addRevealRef = useCallback((el) => {
        if (el && !revealRefs.current.includes(el)) {
            revealRefs.current.push(el);
        }
    }, []);
    useEffect(() => {
        // GSAP Reveal Animation
        revealRefs.current.forEach((container) => {
            const image = container.querySelector('img');

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    toggleActions: 'play none none none',
                },
            });

            tl.set(container, { autoAlpha: 1 });

            tl.from(container, {
                // xPercent: -100,
                duration: 1,
                ease: 'power2.out',
            });

            tl.from(image, {
                xPercent: 100,
                scale: 1,
                delay: -1,
                duration: 1,
                ease: 'power2.out',
            });
        });
    }, []);
    return (
        <>
            <div className="page-contact-us">
                <div className="container">
                    <div className="row">
                        {/* Contact Image Start */}
                        <div className="col-lg-6">
                            <div className="contact-us-image">
                                <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }}>
                                    <img src="images/contact-us-image.jpg" alt="" />
                                </figure>
                            </div>
                        </div>
                        {/* Contact Image End */}
                        {/* Buttons Section Start */}
                        <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
                            <div className="section-title text-center mb-4">
                                <h3 className="wow fadeInUp">Get in touch</h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    We are ready to <span>connect with you</span>
                                </h2>
                                <p className="wow fadeInUp" data-wow-delay="0.2s">
                                    Choose an option below to speak with our team instantly.
                                </p>
                            </div>
                            <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
                                {/* Call Button */}
                                <a href="tel:+919876543210" className="btn-custom grey-btn">
                                    Call Us Now
                                </a>
                                {/* WhatsApp Button */}
                                <a
                                    href="https://wa.me/918830219839?text=Hi, I would like to chat with you."
                                    target="_blank"
                                    className="btn-custom grey-btn"
                                >
                                    Chat with Us
                                </a>
                            </div>
                        </div>
                        {/* Buttons Section End */}
                    </div>
                </div>
            </div>
            <div className="google-map">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title">
                                <h3 className="wow fadeInUp">Our contact</h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    Get in touch with us
                                </h2>
                                <p className="wow fadeInUp" data-wow-delay="0.2s">
                                    Get in touch to discuss your employee wellbeing needs today. Please
                                    give us a call, drop us an email or fill out the contact form and
                                    we'll get back to you.
                                </p>
                            </div>
                            {/* Section Title End */}
                        </div>
                        <div className="col-lg-12">
                            {/* Google Map IFrame Start */}
                            <div className="google-map-iframe">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d232.6243176408832!2d79.05618768220889!3d21.11300143995177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf8fd99219f3%3A0x50aefbee29e0106b!2sEra%20Interior!5e0!3m2!1sen!2sin!4v1751102361508!5m2!1sen!2sin"
                                    width={600}
                                    height={450}
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                            {/* Google Map IFrame End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Contact Info Box Start */}
                            <div className="contact-info-box">
                                {/* Conatct Info Item Start */}
                                <div className="contact-info-item wow fadeInUp">
                                    {/* Icon Box Start */}
                                    <div className="icon-box">
                                        <i className="fa-solid fa-phone" />
                                    </div>
                                    {/* Icon Box End */}
                                    {/* Contact Info Content Start */}
                                    <div className="contact-info-content">
                                        <h3>phone number</h3>
                                        <p>+91 8830219839</p>
                                    </div>
                                    {/* Contact Info Content End */}
                                </div>
                                {/* Conatct Info Item End */}
                                {/* Conatct Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" data-wow-delay="0.2s">
                                    {/* Icon Box Start */}
                                    <div className="icon-box">
                                        <i className="fa-regular fa-envelope" />
                                    </div>
                                    {/* Icon Box End */}
                                    {/* Contact Info Content Start */}
                                    <div className="contact-info-content">
                                        <h3>e-mail support</h3>
                                        <p>enquiry@erainterior.in</p>
                                    </div>
                                    {/* Contact Info Content End */}
                                </div>
                                {/* Conatct Info Item End */}
                                {/* Conatct Info Item Start */}
                                <div className="contact-info-item wow fadeInUp" data-wow-delay="0.4s">
                                    {/* Icon Box Start */}
                                    <div className="icon-box">
                                        <i className="fa-solid fa-house" />
                                    </div>
                                    {/* Icon Box End */}
                                    {/* Contact Info Content Start */}
                                    <div className="contact-info-content">
                                        <h3>headquarter</h3>
                                        <p>
                                            Shop no : 2, Shyama Apartment, Pratap Nagar, Nagpur,
                                            Maharashtra.Pin code: 440022
                                        </p>
                                    </div>
                                    {/* Contact Info Content End */}
                                </div>
                                {/* Conatct Info Item End */}
                            </div>
                            {/* Contact Info Box End */}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default GetInTouch
